var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTools = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_tools",
    d: "M37.576,668.951l-1.383-.3a7.453,7.453,0,0,0-.445-1.074l.766-1.191a.54.54,0,0,0-.072-.671l-2.156-2.156a.54.54,0,0,0-.671-.072l-1.191.766a7.45,7.45,0,0,0-1.074-.445l-.3-1.383a.536.536,0,0,0-.525-.424H27.476a.536.536,0,0,0-.525.424l-.3,1.383a7.45,7.45,0,0,0-1.074.445l-1.191-.766a.54.54,0,0,0-.671.072l-2.156,2.156a.54.54,0,0,0-.072.671l.766,1.191a7.453,7.453,0,0,0-.445,1.074l-1.383.3a.536.536,0,0,0-.424.525v3.048a.536.536,0,0,0,.424.525l1.383.3a7.453,7.453,0,0,0,.445,1.074l-.766,1.191a.54.54,0,0,0,.072.671l2.156,2.156a.54.54,0,0,0,.671.072l1.191-.766a7.45,7.45,0,0,0,1.074.445l.3,1.383a.536.536,0,0,0,.525.424h3.048a.536.536,0,0,0,.525-.424l.3-1.383a7.45,7.45,0,0,0,1.074-.445l1.191.766a.538.538,0,0,0,.671-.072l2.156-2.156a.54.54,0,0,0,.072-.671l-.766-1.191a7.453,7.453,0,0,0,.445-1.074l1.383-.3a.536.536,0,0,0,.424-.525v-3.048A.536.536,0,0,0,37.576,668.951ZM29,675a4,4,0,1,1,4-4A4,4,0,0,1,29,675Z",
    transform: "translate(-20 -662)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTools);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_tools.5113ba02e2805d7d5f78511922339a2c.svg";